import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import React, { useEffect, useState } from "react";

export default function CTASection() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bg-[#0e1a10]">
      <motion.section
        className="text-white text-center py-16 px-6 font-manrope overflow-hidden"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.div
          className="max-w-3xl mx-auto"
          initial={{ scale: 0.95 }}
          whileInView={{ scale: 1 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
        >
          {isLoading ? (
            <div className="animate-pulse space-y-6">
              <div className="h-8 w-3/4 bg-gray-700 mx-auto rounded"></div>
              <div className="h-4 w-5/6 bg-gray-600 mx-auto rounded"></div>
              <div className="h-4 w-2/3 bg-gray-600 mx-auto rounded"></div>
              <div className="w-48 h-10 mx-auto rounded-full bg-green-700/40"></div>
            </div>
          ) : (
            <>
              <h2 className="text-3xl md:text-4xl font-extrabold leading-snug mb-4 text-green-400 drop-shadow-[0_1px_3px_rgba(34,197,94,0.6)]">
                Ready to Transform Your Health and Fitness?
              </h2>

              <p className="text-gray-300 text-base md:text-lg mb-8 leading-relaxed">
                Join thousands of users who trust{" "}
                <span className="text-green-400 font-semibold">FitTrack</span> to guide their health journey. Take the first step toward a better you—start now!
              </p>

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.98 }}
                className="bg-green-500 hover:bg-green-400 text-black px-8 py-3 rounded-full font-semibold text-base md:text-lg shadow-md hover:shadow-green-500/20 transition-all duration-300 ease-in-out border border-green-400 hover:border-green-300"
              >
                <Typewriter
                  words={["Start Your Free Trial", "Get Fit Today", "Join FitTrack Now"]}
                  loop={true}
                  cursor
                  cursorStyle="|"
                  typeSpeed={70}
                  deleteSpeed={40}
                  delaySpeed={1500}
                />
              </motion.button>
            </>
          )}
        </motion.div>
      </motion.section>
    </div>
  );
}
